import React from "react";
import "./GreenBanner.css";
import { FormattedMessage } from "react-intl";

export default function Index({ leftText, rightText }) {
  return (
    <div className="green-banner-wrapper">
      <div className="green-banner">
        <div className="text-wrapper container">
          <div className="row">
            <div className="col-lg-5 col-md-12 left-box">
              <div className="table-wrapper">
                <div className="table-cell">
                  <h2>
                    <FormattedMessage id={leftText} />
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              {rightText.length > 0 ? (
                rightText.map(item => (
                  <p>
                    <FormattedMessage id={item} />
                  </p>
                ))
              ) : (
                <p>
                  <FormattedMessage id={rightText} />
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
